type GoogleIconProps = {
  className?: string;
};

const GoogleIcon = ({ className }: GoogleIconProps) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M23.06 12.25C23.06 11.47 22.99 10.72 22.86 10H12.5V14.26H18.42C18.16 15.63 17.38 16.79 16.21 17.57V20.34H19.78C21.86 18.42 23.06 15.6 23.06 12.25Z"
      fill="#4285F4"
    />
    <path
      d="M12.4997 23.0016C15.4697 23.0016 17.9597 22.0216 19.7797 20.3416L16.2097 17.5716C15.2297 18.2316 13.9797 18.6316 12.4997 18.6316C9.63969 18.6316 7.20969 16.7016 6.33969 14.1016H2.67969V16.9416C4.48969 20.5316 8.19969 23.0016 12.4997 23.0016Z"
      fill="#34A853"
    />
    <path
      d="M6.34 14.0903C6.12 13.4303 5.99 12.7303 5.99 12.0003C5.99 11.2703 6.12 10.5703 6.34 9.91031V7.07031H2.68C1.93 8.55031 1.5 10.2203 1.5 12.0003C1.5 13.7803 1.93 15.4503 2.68 16.9303L5.53 14.7103L6.34 14.0903Z"
      fill="#FBBC05"
    />
    <path
      d="M12.4997 5.38C14.1197 5.38 15.5597 5.94 16.7097 7.02L19.8597 3.87C17.9497 2.09 15.4697 1 12.4997 1C8.19969 1 4.48969 3.47 2.67969 7.07L6.33969 9.91C7.20969 7.31 9.63969 5.38 12.4997 5.38Z"
      fill="#EA4335"
    />
  </svg>
);

export default GoogleIcon;
